module.exports = __webpack_public_path__ + "BradescoSans-Light.81da6a0ecf8167a99f98.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/BradescoSans/BradescoSans-Light.woff
// module id = ../../../../../src/assets/fonts/BradescoSans/BradescoSans-Light.woff
// module chunks = main